export function calculateDistance(p1, p2) {
  return Math.sqrt(
    Math.pow(p2.x - p1.x, 2) +
      Math.pow(p2.y - p1.y, 2) +
      Math.pow(p2.z - p1.z, 2)
  );
}

export function calculateAngle(p1, p2, p3) {
  // p2 is the vertex (e.g., elbow)
  const v1 = { x: p1.x - p2.x, y: p1.y - p2.y, z: p1.z - p2.z };
  const v2 = { x: p3.x - p2.x, y: p3.y - p2.y, z: p3.z - p2.z };

  const dotProduct = v1.x * v2.x + v1.y * v2.y + v1.z * v2.z;
  const mag1 = Math.sqrt(v1.x * v1.x + v1.y * v1.y + v1.z * v1.z);
  const mag2 = Math.sqrt(v2.x * v2.x + v2.y * v2.y + v2.z * v2.z);

  // Handle cases where magnitude is zero to avoid NaN
  if (mag1 === 0 || mag2 === 0) {
    return 0;
  }

  const cosAngle = dotProduct / (mag1 * mag2);

  // Clamp the value to [-1, 1] to avoid floating point errors with acos
  const clampedCosAngle = Math.max(-1, Math.min(1, cosAngle));

  const angleRad = Math.acos(clampedCosAngle);
  return angleRad * (180 / Math.PI); // Convert to degrees
}
